import { get, post } from "services/network/endpoint";
import * as ActionTypes from "services/state/action-types";
import { BFF } from "../../network/routes";

export function getRechargeValues(callback) {
  return (dispatch) => {
    let config = {
      pathValues: {},
      client: BFF,
    };
    const request = get("getRechargeValues", config);
    dispatch({
      type: ActionTypes.GET_RECHARGE_HASH,
      payload: request,
    }).then(callback);
  };
}

export function getRechargeCard(body, callback) {
  return (dispatch) => {
    let config = {
      pathValues: {},
      data: body,
      client: BFF,
    };
    const request = post("getRechargeCard", config);
    dispatch({
      type: ActionTypes.GET_RECHARGE_CARDS,
      payload: request,
    }).then(callback);
  };
}

export function rechargeHash(callback) {
  return (dispatch) => {
    const config = {
      pathValues: {},
      data: {},
      client: BFF,
    };

    const request = post("rechargeHash", config);
    dispatch({
      type: ActionTypes.GET_RECHARGE_HASH,
      payload: request,
    }).then(callback);
  };
}

export function addRechargeCard(body, callback) {
  return (dispatch) => {
    const config = {
      pathValues: {},
      data: body,
      client: BFF,
    };

    const request = post("addRechargeCard", config);
    dispatch({
      type: ActionTypes.SEND_NEW_CARD,
      payload: request,
    }).then(callback);
  };
}

export function deleteRechargeCard(body, callback) {
  return (dispatch) => {
    const config = {
      pathValues: {},
      data: body,
      client: BFF,
    };

    const request = post("deleteRechargeCard", config);
    dispatch({
      type: ActionTypes.DELETE_CARD,
      payload: request,
    }).then(callback);
  };
}

export function rechargeLogin(callback) {
  return (dispatch) => {
    const config = {
      pathValues: {},
      client: BFF,
    };

    const request = post("rechargeLogin", config);
    dispatch({
      type: ActionTypes.RECHARGE_LOGIN,
      payload: request,
    }).then(callback);
  };
}

export function makeRecharge(body, callback) {
  return (dispatch) => {
    let config = {
      pathValues: {},
      data: body,
      client: BFF,
    };
    const request = post("makeRecharge", config);
    dispatch({
      type: ActionTypes.CREATE_RECHARGE,
      payload: request,
    }).then(callback);
  };
}

export function financialHistoryByDocument(body, callback) {
  return (dispatch) => {
    let config = {
      pathValues: {},
      data: body,
      client: BFF,
    };
    const request = post("financialHistoryByDocument", config);
    dispatch({
      type: ActionTypes.GET_RECHARGE_HISTORY_BY_DOCUMENT,
      payload: request,
    }).then(callback);
  };
}



// WEBPACK FOOTER //
// ./src/services/state/trafficPreControle/action.js